var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRevaluation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9381_9964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1171 11.31C11.2566 12.3632 9.95623 13.0352 8.49898 13.0352C5.90904 13.0352 3.80921 10.9112 3.80921 8.29134H5.06388L3.11653 4.8783L1.16699 8.29354H2.38246C2.38246 11.711 5.12051 14.4828 8.50116 14.4828",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8811 5.27492C5.74151 4.2217 7.04193 3.54967 8.49918 3.54967C11.0891 3.54967 13.1889 5.67373 13.1889 8.29356H11.9343L13.8838 11.7088L15.8333 8.29356H14.6179C14.6179 4.87611 11.8798 2.10425 8.49918 2.10425",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71871 7.16315C9.71871 7.16315 9.31791 6.3501 8.45751 6.3501C7.4468 6.3501 6.98283 7.68315 7.93037 8.16569C8.41176 8.41026 9.69475 8.53586 9.66861 9.58907C9.63812 10.7833 7.74304 10.9618 7.28125 9.72128",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49902 6.36997V5.23523",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49902 11.7065V10.5718",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9381_9964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRevaluation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/revaluation.b8ad22ac.svg";
export { ForwardRef as ReactComponent };